import React from 'react';
import AisinoButton from "../../baseComponent/button/AisinoButton";

class AisinoTableButton extends React.Component{
    render() {
        return (
            <AisinoButton {...this.props} >{this.props.label}</AisinoButton>
        )
    }
}
export default AisinoTableButton;
